export interface DiffResult {
    [key: string]: any;
  }
  
  const alwaysIncludeFields = ['id', 'user_id'];
  
  export function getObjectDiff(original: any, modified: any): any {
    if (typeof original !== typeof modified) {
      return modified;
    }
  
    if (original === null || modified === null) {
      return original === modified ? undefined : modified;
    }
  
    if (typeof original !== "object") {
      return original === modified ? undefined : modified;
    }
  
    if (Array.isArray(original) && Array.isArray(modified)) {
      const diff: any[] = [];
      for (let i = 0; i < modified.length; i++) {
        const originalItem = original[i];
        const modifiedItem = modified[i];
  
        const itemDiff = getObjectDiff(originalItem, modifiedItem);
        if (itemDiff !== undefined) {
          diff.push(itemDiff);
        }
      }
  
      return diff.length > 0 ? diff : undefined;
    }
  
    const diff: DiffResult = {};
    let hasChanges = false;
  
    for (const key in modified) {
      if (!Object.prototype.hasOwnProperty.call(modified, key)) {
        continue;
      }
  
      if (alwaysIncludeFields.includes(key)) {
        continue;
      }
  
      const originalValue = original[key];
      const modifiedValue = modified[key];
  
      const valueDiff = getObjectDiff(originalValue, modifiedValue);
  
      if (valueDiff !== undefined) {
        diff[key] = valueDiff;
        hasChanges = true;
      }
    }
  
    for (const key in original) {
      if (!Object.prototype.hasOwnProperty.call(original, key)) {
        continue;
      }
  
      if (alwaysIncludeFields.includes(key)) {
        continue;
      }
  
      if (!(key in modified)) {
        diff[key] = null;
        hasChanges = true;
      }
    }
  
    if (hasChanges) {
      for (const field of alwaysIncludeFields) {
        if (Object.prototype.hasOwnProperty.call(modified, field)) {
          diff[field] = modified[field];
        } else if (Object.prototype.hasOwnProperty.call(original, field)) {
          diff[field] = original[field];
        }
      }
    }
  
    return hasChanges ? diff : undefined;
  }